<template>
    <div class="content-container">
        <div class='title'>
            {{$t('outils.compteur.step.three.title.ajout.compteur')}}
            <ReglePastille cle="outils.etape3Compteurs" />
        </div>
        <div class='margin-top-20px pre-line'>{{$t('outils.compteur.step.three.subtitle.ajout.compteur')}}</div>

        <CompteurDataTable
            :table-header='tableHeader'
            :table-data='compteurs'
            :count='compteurs.length'
            class='table'/>
        <div class='width-60pct'>
            <ButtonBlue @click='addCompteur'
                        :text="$t('outils.compteur.step.three.boutton.ajouter.compteur')"
                        class='blueBtn bouton-ajout'
                        :disabled='ajoutDisabled'
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { COMPTEUR } from '@/modules/Outils/store/mutation-types';
import { TableHeader } from '@/models/TableHeader';
import { SortType } from '@/models/SortType';
import ButtonBlue from '@/components/ui-components/Button.vue';
import CompteurDataTable from '@/modules/Outils/components/CompteurDataTable.vue';
import { Compteur } from '@/modules/Outils/store/state';
import ReglePastille from '@/components/regles/ReglePastille.vue';

interface Data {
    tableHeader: TableHeader[];
}

export default defineComponent({
    emits: ['next'],
    components: { ButtonBlue, CompteurDataTable, ReglePastille },
    data(): Data {
        return {
            tableHeader: [{
                label: this.$t('outils.compteur.step.three.table.header.numero.compteur'),
                sortData: 'none',
                sortStatus: SortType.INACTIVE,
                width: '50%',
                textalign: 'center'
            },
                {
                    label: this.$t('outils.compteur.step.three.table.header.facture'),
                    sortData: 'none',
                    sortStatus: SortType.INACTIVE,
                    width: '50%',
                    textalign: 'center'
                },
                {
                    label: '',
                    sortData: 'none',
                    sortStatus: SortType.INACTIVE,
                    width: '10%',
                    textalign: 'center'
                },
            ]
        };
    },
    methods: {
        addCompteur(): void {
            this.$store.commit(COMPTEUR.ADD_COMPTEUR);
        }
    },
    computed: {
        ajoutDisabled() : boolean {
            return this.compteurs[this.compteurs.length - 1].numeroCompteur.trim() === '' &&
                this.compteurs[this.compteurs.length - 1].facture == undefined;
        },
        compteurs: {
            get(): Compteur[] {
                return this.$store.getters.getCompteurs;
            },
            set(value: string) {
                this.$store.commit(COMPTEUR.SET_ADRESSE_POSTALE, value.trim());
            },
        }
    },

});
</script>

<style scoped>
.content-container {
    margin-top: 8px;
    padding: 16px 24px;
    overflow: auto;
    background-color: #fff;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
}
.title {
    color: var(--dark-blue);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-low-large);
}
.margin-top-20px {
    margin-top: 20px;
}
.pre-line {
    white-space: pre-line;
}
.table {
    width: 60%;
    margin-top: 20px;
}
.bouton-ajout {
    margin-top: 10px;
    float: right;
}
.width-60pct {
    width: 60%;
    height: 45px;
}
</style>
